import dayjs from "dayjs"
import { WEEKDAYS } from "./constants"

export const transformTripAssignmentsFromAPI = (tripAssignments) => {
  if (!tripAssignments || tripAssignments.length === 0) return []

  return tripAssignments?.map((assignment) => ({
    id: assignment.id,
    trip_id: assignment.trip_info.id,
    _destroy: false
  }))
}

export const transformLicensesFromAPI = (staffDocuments) => {
  if (!staffDocuments || staffDocuments.length === 0) return []

  return staffDocuments?.map((doc) => ({
    id: doc.id,
    name: doc.file_name || "",
    description: doc.notes || "",
    issueDate: doc.issue_date ? dayjs(doc.issue_date) : null,
    expiryDate: doc.expiry_date ? dayjs(doc.expiry_date) : null,
    file: null,
    fileUrl: doc.file_url || null,
    _destroy: false
  }))
}

export const transformTimeBlocksFromAPI = (timeBlocks, daysList) => {
  if (!timeBlocks || !daysList || daysList.length === 0) return [{ start: null, end: null }]

  const firstDayBlocks = timeBlocks[daysList[0]]
  if (!firstDayBlocks || firstDayBlocks.length === 0) return [{ start: null, end: null }]

  return firstDayBlocks?.map((block) => ({
    start: block.start ? dayjs(block.start, "HH:mm") : null,
    end: block.end ? dayjs(block.end, "HH:mm") : null
  }))
}

export const transformSeasonalTimeBlocksFromAPI = (timeBlocks, daysList) => {
  if (!daysList || daysList.length === 0 || !timeBlocks || !timeBlocks[daysList[0]]) {
    return [{ id: Date.now(), startTime: null, endTime: null }]
  }

  return timeBlocks[daysList[0]]?.map((block, idx) => ({
    id: Date.now() + idx,
    startTime: block.start ? dayjs(block.start, "HH:mm") : null,
    endTime: block.end ? dayjs(block.end, "HH:mm") : null
  }))
}

export const transformAllYearAvailability = (availability) => {
  const timeBlocks = availability.time_blocks || {}
  const days = Object.keys(timeBlocks).filter((day) => timeBlocks[day] === true || (Array.isArray(timeBlocks[day]) && timeBlocks[day].length > 0))

  return {
    days
  }
}

export const transformSeasonalAvailabilities = (availabilities) => {
  return availabilities?.map((availability) => {
    const seasonTimeBlocks = availability.time_blocks || {}
    const seasonDays = Object.keys(seasonTimeBlocks).filter((day) => seasonTimeBlocks[day] === true || (Array.isArray(seasonTimeBlocks[day]) && seasonTimeBlocks[day].length > 0))

    return {
      id: availability.id || Date.now(),
      from: availability.season_start ? dayjs(availability.season_start).format("MM/DD/YYYY") : null,
      to: availability.season_end ? dayjs(availability.season_end).format("MM/DD/YYYY") : null,
      recurringYearly: availability.recurring_yearly || false,
      selectedDays: seasonDays,
      _destroy: false
    }
  })
}

export const transformTimeBlocksToAPI = (timeBlocks) => {
  return timeBlocks
    ?.filter((block) => block.start && block.end)
    ?.map((block) => ({
      start: dayjs(block.start).format("HH:mm"),
      end: dayjs(block.end).format("HH:mm")
    }))
}

export const transformSeasonalTimeBlocksToAPI = (timeBlocks) => {
  return (
    timeBlocks
      ?.filter((block) => block.startTime && block.endTime)
      ?.map((block) => ({
        start: dayjs(block.startTime).format("HH:mm"),
        end: dayjs(block.endTime).format("HH:mm")
      })) || []
  )
}

export const createTimeBlocksData = (selectedDays, timeBlocksArray) => {
  const timeBlocksData = {}
  WEEKDAYS.forEach((day) => {
    timeBlocksData[day] = selectedDays.includes(day) ? timeBlocksArray : []
  })
  return timeBlocksData
}

export const transformExperiencesToOptions = (experiences) => {
  return experiences?.map((exp) => ({
    value: exp.id,
    label: exp.title,
    guests: exp.min_guests || 0,
    price: exp.min_price || 0,
    status: exp.status || "draft"
  }))
}

export const transformRolesToOptions = (roles) => {
  return roles?.map((role) => ({
    value: role.id,
    label: role.name
  }))
}
